<template>
  <data-list
    ref="dataList"
    class="content md"
    :url="url"
    entity-name="消防演习"
    hide-action
    :action="action"
    :columns="columns"
    :modal-width="640"
    :modal-form="{
      layout: 'horizontal',
      labelAlign: 'left',
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
    }"
    :search-key-type="searchKeyType"
  >
    <template v-slot:query="{ form }">
      <a-form-model-item label="提交时间">
        <a-range-picker
          v-model="form.create_time"
          :placeholder="['开始时间', '结束时间']"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          allow-clear
          @change="updateList"
          class="range-picker date"
        />
      </a-form-model-item>
      <a-form-model-item label="演习类型">
        <a-select
          style="width: 180px"
          placeholder="演习类型"
          @change="updateList"
          :options="exerciseOptions"
          v-model="form.type"
          allow-clear
        ></a-select>
      </a-form-model-item>
      <a-form-model-item label="演习名称">
        <a-input-search v-model="form.name" placeholder="输入演习名称查询" allow-clear></a-input-search>
      </a-form-model-item>
    </template>
    <template v-slot:button="{ form }">
      <a-button type="primary" @click="exportData(form)" :loading="exporting">
        {{ exporting ? "正在导出" : "数据导出" }}
      </a-button>
    </template>
  </data-list>
</template>

<script>
import { getTemple } from "@/common/js/storage";
import { downLoadBlobFile, getKeyTitle, isEmpty } from "@/common/js/tool";
import { exerciseOptions } from "@/common/constant/exercise";

export default {
  name: "Exercise",
  data() {
    return {
      url: "/admin/record-fire-drill",
      columns: [
        { title: "提交时间", dataIndex: "create_time" },
        {
          title: "提交人",
          dataIndex: "wx_user_id",
          customRender: (text) => <open-data type="userName" openid={text} />,
        },
        { title: "演习名称", dataIndex: "name" },
        { title: "演习类型", dataIndex: "type", customRender: (text) => getKeyTitle(exerciseOptions, text) },
        {
          title: "演习图片",
          dataIndex: "img",
          customRender: (text) => {
            const imgList = JSON.parse(text);
            const cover = imgList?.[0]?.url;
            return <img class="avatar" src={cover} />;
          },
        },
      ],
      searchKeyType: {
        create_time: (form, key) => {
          let res = "";
          const value = form[key];
          if (value?.length === 2) {
            res = `&filter[create_time][gte]=${value[0]} 00:00:00&&filter[create_time][lte]=${value[1]} 23:59:59`;
          }
          return res;
        },
        name: 1,
      },
      exerciseOptions: exerciseOptions,
      exporting: false,
    };
  },
  computed: {
    action() {
      return this.$route.meta.action;
    },
  },
  methods: {
    updateList() {
      this.$refs.dataList.updateList();
    },
    exportData(form) {
      if (this.exporting) return;
      this.exporting = true;
      const temple = getTemple();
      let url = `${this.url}/export?temple_id=${temple}`;
      if (form.create_time?.length === 2) {
        url += `&start_time=${form.create_time[0]}&end_time=${form.create_time[1]}`;
      }
      if (!isEmpty(form.name)) {
        url += `&name=${form.name}`;
      }
      if (form.type) {
        url += `&type=${form.type}`;
      }
      this.$axios(url, { noTempleFilter: true, responseType: "blob" })
        .then((res) => {
          downLoadBlobFile(res, "消防演习记录");
        })
        .finally(() => {
          this.exporting = false;
        });
    },
  },
};
</script>

<style lang="less" scoped></style>
